import {getImageFileFormatFromContentType} from './getImageFileFormatFromContentType';

export function getImageFileFormatFromHeaders(headers: Headers) {
  const contentType = headers.get('Content-Type');
  return getImageFileFormatFromContentType(contentType);
}
